export default __webpack_public_path__ + "static/media/user.9038b348.svg";